import {getFilenameFromContentDisposition} from "../helper/headers";

/**
 * Class ReportManager.js
 *
 * @class ReportManager
 * @date
 * @author
 * @copyright UniWeb bvba 2026
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/ReportManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export class ReportManager {
    constructor(
        apiRouter,
        store,
        authenticator,
    ) {
        /** @type ApiRouter */
        this.apiRouter = apiRouter;
        /** @type Vuex */
        this.store = store;
        /** @type AuthenticationManager */
        this.authenticator = authenticator;
    }

    async getReports() {
        // Refresh token to be secure:
        const tokenResult = await this.authenticator.fetchNewTokens(this.authenticator.getRefreshToken());

        if (tokenResult?.authToken !== null) {
            this.store.dispatch('login', tokenResult);
        }

        let filename = '';
        fetch(this.apiRouter.getRoute('retrieveReports'), {
            headers: new Headers({
                'Authorization': 'Bearer ' + this.store.state.authToken,
            }),
        })
            .then( res => {
                if (res.status === 200) {
                    filename = 'reports.zip';
                }
                return res.blob();
            } )
            .then( blob => {
                const file = window.URL.createObjectURL(blob);
                // window.location.assign(file);
                let a = document.createElement('a');
                a.href = file;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
    }
}
